import styled from 'styled-components'

const Group = styled.div`
    position: relative;
    margin: 0 auto;
    > input + svg {
        position: absolute;
        top: .6rem;
        right: .2rem;
    }
    &.icon > input{
        padding: .3rem 1.7rem .3rem .3rem;
    }
    ${props => props.minHeight && `min-height:${props.minHeight};`}
    ${props => props.width && `width:${props.width};`}
`

export default Group